// src/App.js
import { Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { CategoryProvider } from './contexts/CategoryContext';

import AppLayout from './layouts/AppLayout';

/* ── 페이지 컴포넌트들 ── */
import Login from './Login';
import Signup from './Signup';
import PublicOnly from './routes/PublicOnly';
import Main from './Main';
import MyPage from './components/MyPage';
import ChatRoutes from './components/Chat';
import JokboPage from './components/Jokbo/JokboPage';
import CalendarView from './components/Calendar/CalendarView';
import Board from './components/Boards';
import CreatePost from './components/Posts/CreatePost';
import PostView from './components/Posts';
import EditPost from './components/Posts/EditPost';
import PointHistory from './components/Points/PointHistory';
import ItemDraw from './components/Gacha/ItemDraw';
import GachaHistory from './components/Gacha/GachaHistory';
import TitleGachaRoulette from './components/Gacha/TitleGachaRoulette';
import StoreMain from './components/Store';
import ItemStore from './components/Store/ItemStore';
import EmoticonStore from './components/Store/EmoticonStore';
import GachaBoxCategory from './components/Gacha/GachaBoxCategory';
import GachaBoxDraw from './components/Gacha/GachaBoxDraw';
import MinihomeView from "./components/Minihome/MinihomeView";
import MinihomeEditor from "./components/Minihome/MinihomeEditor";
import MiniroomEditor from './components/Miniroom/MiniroomEditor';
import TreePage from './components/Events/Tree/TreePage';
import NewYearEventPage from './components/Events/NewYear/NewYearEventPage';
// ✅ Topic Mafia
import TopicMafiaLobby from './components/TopicMafia/TopicMafiaLobby';
import TopicMafiaRoom from './components/TopicMafia/TopicMafiaRoom';


/* ── 어드민 컴포넌트들 ── */
import ContentManager from './components/Admin/ContentManager';
import UserManagerPage from './components/Admin/UserManager';
import GachaAndTitleManager from './components/Admin/GachaAndTitleManager';
import PostCommentManager from './components/Admin/PostCommentManager';
import ReportManager from './components/Admin/ReportManager';
import CreatePostPointSetting from './components/Admin/PostManager/CreatePostPointSetting';
import CreateCommentPointSetting from './components/Admin/CommentManager/CreateCommentPointSetting';
import StoreManager from './components/Admin/StoreManager';
import AdminChatLogManager from './components/Admin/ChatManager/AdminChatLogManager';
import ChatLogPage from './components/Admin/ChatManager/Chat/ChatLogPage';
import LuckyBoxManager from './components/Admin/LuckyBoxManager/LuckyBoxManager';
import UserMessageStats from './components/Admin/ChatManager/Chat/UserMessageStats';
import { AdminAlertProvider } from './contexts/AdminAlertContext'; // ✅ 상단 import 추가
import ForbiddenPage from './components/ForbiddenPage';
import GlobalHardReload from './components/Common/GlobalHardReload'; // ✅ 추가




import './App.css';

/* ─────────────────────────── 메인 레이아웃 내부 라우팅 ─────────────────────────── */
function MainRoutes() {
  return (
    <Routes>
      {/* 메인 */}
      <Route index element={<Main />} />

      {/* 일반 메뉴 */}
      <Route path="jokbo" element={<JokboPage />} />
      <Route path="calendar" element={<CalendarView />} />
      <Route path="mypage" element={<MyPage />} />
      <Route path="points" element={<PointHistory />} />
      <Route path="events/tree" element={<TreePage />} />
      <Route path="events/newyear" element={<NewYearEventPage />} />

      {/* 채팅 */}
      <Route path="chat/*" element={<ChatRoutes />} />

      {/* 게시판 / 게시글 */}
      <Route path="board" element={<Board />} />
      <Route path="posts/create" element={<CreatePost />} />
      <Route path="posts/:post_id" element={<PostView />} />
      <Route path="posts/:post_id/edit" element={<EditPost />} />

      {/* 스토어 */}
      <Route path="store/*" element={<StoreMain />}>
        <Route index element={<ItemStore />} />
        <Route path="emoticons" element={<EmoticonStore />} />
      </Route>

      {/* 가챠 */}
      <Route path="gacha/item" element={<ItemDraw />} />
      <Route path="gacha/history" element={<GachaHistory />} />
      <Route path="gacha/title" element={<TitleGachaRoulette />} />
      <Route path="gacha/luckybox" element={<GachaBoxCategory />} />
      <Route path="gacha/luckybox/draw" element={<GachaBoxDraw />} />

      {/* ✅ 게임: Topic Mafia (여기서 절대경로 쓰지 말기!) */}
      <Route path="games/topic-mafia" element={<TopicMafiaLobby />} />
      <Route path="games/topic-mafia/:roomId" element={<TopicMafiaRoom />} />

      {/* 어드민 */}
      <Route path="admin/content-manager" element={<ContentManager />} />
      <Route path="admin/users" element={<UserManagerPage />} />
      <Route path="admin/post-comment" element={<PostCommentManager />} />
      <Route path="admin/gacha-title" element={<GachaAndTitleManager />} />
      <Route path="admin/reports" element={<ReportManager />} />
      <Route path="admin/store/*" element={<StoreManager />} />
      <Route path="admin/chat-category" element={<AdminChatLogManager />} />
      <Route path="admin/chat-log-manager" element={<AdminChatLogManager />} />
      <Route path="admin/chat-log-page" element={<ChatLogPage />} />
      <Route path="admin/point-policy" element={<CreatePostPointSetting />} />
      <Route path="admin/comment-point" element={<CreateCommentPointSetting />} />
      <Route path="admin/user-message-stats" element={<UserMessageStats />} />
      <Route path="admin/luckybox-manager" element={<LuckyBoxManager />} />
    </Routes>
  );
}

/* ─────────────────────────── 퍼블릭/메인 라우팅 ─────────────────────────── */
function AppContent() {
  return (
    <Routes>
      {/* 퍼블릭 페이지 (세션 O → 홈으로) */}
      <Route path="/" element={
        <PublicOnly>
          <Login />
        </PublicOnly>
      } />
      <Route path="/login" element={
        <PublicOnly>
          <Login />
        </PublicOnly>
      } />
      <Route path="/signup" element={
        <PublicOnly>
          <Signup />
        </PublicOnly>
      } />

      {/* 메인 레이아웃 */}
      <Route path="/main/*" element={
        <AppLayout>
          <MainRoutes />
        </AppLayout>
      } />

      {/* ✅ 미니홈 뷰/편집 라우트는 반드시 Routes 내부에 */}
      <Route path="/u/:username/home" element={
        <AppLayout>
          <MinihomeView />
        </AppLayout>
      } />
      <Route path="/me/home/edit" element={
        <AppLayout>
          <MinihomeEditor />
        </AppLayout>
      } />
      <Route path="/me/room/edit" element={
        <AppLayout>
          <MiniroomEditor />
        </AppLayout>
      } />

      {/* 403 */}
      <Route path="/403" element={<ForbiddenPage />} />

      {/* 잘못된 주소 → 홈 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

/* ─────────────────────────── Root App ─────────────────────────── */
export default function App() {
  return (
    <UserProvider>
      <CategoryProvider>
        <AdminAlertProvider>
          <div className="App">
            <AppContent />
            <GlobalHardReload exclude={['/login', '/signup']} />
          </div>
        </AdminAlertProvider>
      </CategoryProvider>
    </UserProvider>
  );
}